import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { CommandCenterReport } from "src/app/shared/models/CommandCenterReportConfiguration.item";
import { FocusLinkProduct } from "src/app/shared/models/enums/FocusLInkProduct.enum";
import { ProductUseItem } from "src/app/shared/models/ProductUse.item";

@Component({
	selector: "app-product-use-report",
	templateUrl: "./product-use-report.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class ProductUseReportComponent implements OnInit {
	@Input() report: CommandCenterReport;
	@Output() reportChange = new EventEmitter<CommandCenterReport>();

	@Input() productOption: string;

	startDate: Date;
	endDate: Date;
	product: string;
	productList: {
		label: string;
		value: string;
	}[] = [];

	productUseSelected: ProductUseItem;

	moment: any = moment;

	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		Object.keys(FocusLinkProduct).forEach((p) => {
			this.productList.push({
				label: p,
				value: FocusLinkProduct[p],
			});
		});

		if (this.venueService.productStatistics.value.length === 0) {
			this.run();
		}
	}

	async run() {
		this.venueService.productStatisticGet(this.venueService.venueKey);
	}
}
